$(document).ready(function(){
  //call imagePanning fn when DOM is ready
  $(".header-template-background-wrapper").imagePanning();
});
